function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M202.2 49.8l-11.4 22.4-21.1 41.4h59.9l-38.1 56.1v-35.2h-52.9l43.2-84.7h20.4m46.5-28.5h-84.3L92.1 163H163v99.2L283.5 85.1h-67.3l32.5-63.8zM118.9 78.2H56.6L71 49.9h62.4zM75.9 163H13.5L28 134.7h62.3zM97.2 120.6H14.1l14.4-28.3h83.1z"
})));